import * as Sentry from '@sentry/browser';
import React, { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { useAppSelector } from '@/store/hooks';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleError = (error: unknown, _info:ErrorInfo) => {
  Sentry.captureException(error);
};

const SentryBoundary = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  const { user } = useAppSelector((state) => state.auth.userPassport) ?? {};
  const viewId = useAppSelector((state)=>state.viewPage.selectedViewId);

  Sentry.setUser({
    id: user?.user_id ?? "N/A",
    username: user?.user_name ?? "N/A",
  });

  Sentry.setTag("customer_id", user?.customer_id?.toString() ?? "N/A");
  Sentry.setTag("customer_name", user?.customer_name ?? "N/A");
  Sentry.setTag("personnel_id", user?.emp_id?.toString() ?? "N/A");
  Sentry.setTag("is_admin", user?.is_admin.toString() ?? "N/A");
  Sentry.setTag("is_super_admin", user?.is_super_admin.toString() ?? "N/A");
  Sentry.setTag("view_id", viewId?.toString() ?? "N/A");
  Sentry.setTag("user_agent", navigator.userAgent);
  Sentry.setTag("os_platform", navigator.platform);
  Sentry.setTag("current_url", window.location.href);

  return (
    <ErrorBoundary fallback={<p>Something went wrong.</p>} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};

export default SentryBoundary;
